import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './Modal.css';

const PublicModal = ({ isOpen, onClose, deal }) => {
  if (!deal) return null;

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="modal-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
        >
          <motion.div
            className="modal-container"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.9 }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-header">
              <h2>{deal.companyName}</h2>
              <button className="modal-close" onClick={onClose}>×</button>
            </div>

            <div className="modal-body">
              <div className="modal-section">
                <h3>Deal Information</h3>
                <div className="detail-grid">
                  <div className="detail-item">
                    <span className="detail-label">MOU Number:</span>
                    <span className="detail-value">{deal.mouNumber}</span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">Company:</span>
                    <span className="detail-value">{deal.companyName}</span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">Student Name:</span>
                    <span className="detail-value">{deal.studentName}</span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">Phone:</span>
                    <span className="detail-value">{deal.phone}</span>
                  </div>
                </div>
              </div>

              <div className="modal-section">
                <h3>Verification Status</h3>
                <div className="detail-grid">
                  <div className="detail-item">
                    <span className="detail-label">MOU Status:</span>
                    <span className={`status-badge ${deal.mouVerified ? 'verified' : 'pending'}`}>
                      {deal.mouVerified ? '✓ Verified' : '⏳ Pending'}
                    </span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">Payment Status:</span>
                    <span className={`status-badge ${deal.paymentVerified ? 'verified' : 'pending'}`}>
                      {deal.paymentVerified ? '✓ Verified' : '⏳ Pending'}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default PublicModal;
